import React from 'react'
import Table from 'uiKit/table/Table'
import TableRow from 'uiKit/table/TableRow'
import TableCell from 'uiKit/table/TableCell'
import Pagination from 'uiKit/table/Pagination'
import { PaginationSpacer } from './SupervisionStyle'
import NoChartData from 'uiKit/NoChartData'
import { formatAccountStatus } from '../TotalUsers/AccountStatusFilter'

const ucFirst = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)

const baseColumnTitles = [
  { title: 'First name', maxWidth: 180, marginRight: 10 },
  { title: 'Last name', maxWidth: 180, marginRight: 10 },
  { title: 'Supervision name', maxWidth: 204, marginRight: 10 },
  { title: 'Due date', maxWidth: 176 },
  { title: 'Submitted at', maxWidth: 176 },
  { title: 'Status', maxWidth: 160 },
  { title: 'Sentiment', maxWidth: 160 },
  {
    title: 'Account status',
    maxWidth: 160,
    tooltipPlace: 'left',
    tooltipText:
      'Displays the current account status of each user, showing active users and inactive users who have been deleted.',
  },
]

type Row = {
  id: number
  firstName: string
  lastName: string
  status: string
  sentiment: string | null
  templateName: string | null
  submttedAt: string | null
  dueDate: string | null
  accountStatus: string
}

const sentimentColor = (value: string) => {
  const v = (value || '').toUpperCase()
  if (v === 'POSITIVE') return 'var(--color-text-success)'
  if (v === 'NEGATIVE') return 'rgba(242, 153, 74, 1)'
  return 'var(--color-subtitle)'
}

type Props = {
  rows: Row[]
  totalCount: number
  page: number
  onPageChange: (nextPage: number) => void
  loading?: boolean
  showAccountStatus?: boolean
}

const SupervisionTable: React.FC<Props> = ({
  rows,
  totalCount,
  page,
  onPageChange,
  loading,
  showAccountStatus = false,
}) => {
  const columnTitles = showAccountStatus
    ? baseColumnTitles
    : baseColumnTitles.filter(column => column.title !== 'Account status')

  if (!loading && rows.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 0' }}>
        <NoChartData text={'No Supervisions found'} />
      </div>
    )
  }

  return (
    <>
      <Table titles={columnTitles}>
        {rows.map((row, idx) => (
          <TableRow key={row.id} style={{ background: idx % 2 ? 'var(--color-table-row-primary)' : undefined }}>
            <TableCell style={{ maxWidth: columnTitles[0].maxWidth, marginRight: 10 }}>{row.firstName}</TableCell>
            <TableCell style={{ maxWidth: columnTitles[1].maxWidth, marginRight: 10 }}>{row.lastName}</TableCell>
            <TableCell style={{ maxWidth: columnTitles[2].maxWidth, marginRight: 10 }}>{row?.templateName || '-'}</TableCell>
            <TableCell style={{ maxWidth: columnTitles[3].maxWidth }}>{row?.dueDate || '-'}</TableCell>
            <TableCell style={{ maxWidth: columnTitles[4].maxWidth }}>{row?.submttedAt || '-'}</TableCell>
            <TableCell style={{ maxWidth: columnTitles[5].maxWidth }}>
              {ucFirst(row.status === 'due' ? 'To be completed' : row.status)}
            </TableCell>
            <TableCell style={{ maxWidth: columnTitles[6].maxWidth, color: sentimentColor(row.sentiment || ''), textTransform: 'capitalize' }}>
              {row.sentiment || '-'}
            </TableCell>
            {showAccountStatus && (
              <TableCell style={{ maxWidth: columnTitles[7].maxWidth }}>
                {formatAccountStatus(row.accountStatus)}
              </TableCell>
            )}
          </TableRow>
        ))}
      </Table>

      <PaginationSpacer>
        <Pagination page={page} rowsPerPage={10} count={totalCount} onChangePage={(_, nextPage) => onPageChange(nextPage)} />
      </PaginationSpacer>
    </>
  )
}

export default SupervisionTable
